export { default } from './RecentlyReturnedSummaryView';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedSummaryView/index.js